<div
    class="badge fx-row fx-layout-align-start-center"
    [class.header]="headerStyle"
    [class.available]="connector | isAvailable"
    [class.faulted]="connector | isFaulted"
    [class.charging]="connector | isCharging"
    [class.preparing]="connector | isPreparing"
    [class.finishing]="connector | isFinishing"
    [class.self-test]="connector | isSelfTest"
    [class.reserved]="connector | isReserved"
    [dialogLink]="
        headerStyle
            ? undefined
            : [
                  'connector',
                  connector?.stationId || globalSearchConnector?.stationId || globalSearchConnector?.station?.stationId,
                  connector?.evseId || globalSearchConnector?.evseId,
              ]
    "
>
    <!-- connector icon -->
    <mat-icon svgIcon="k-connector"></mat-icon>

    <!-- connector location -->
    <div class="info fx-column fx-flex">
        <span class="content" [attr.title]="location | ceCustomerPrivacy: 'location'"> Connector </span>
        <span i18n="Connector badge|Badge header">{{ location | ceCustomerPrivacy: 'location' }} </span>
    </div>

    <!-- connector id -->
    <ce-connector-pill [connector]="connector" [globalSearchConnector]="globalSearchConnector"></ce-connector-pill>
</div>
